import { render, staticRenderFns } from "./CsgDataForm.vue?vue&type=template&id=5e302d7b&scoped=true"
import script from "./CsgDataForm.vue?vue&type=script&lang=js"
export * from "./CsgDataForm.vue?vue&type=script&lang=js"
import style0 from "./CsgDataForm.vue?vue&type=style&index=0&id=5e302d7b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e302d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e302d7b')) {
      api.createRecord('5e302d7b', component.options)
    } else {
      api.reload('5e302d7b', component.options)
    }
    module.hot.accept("./CsgDataForm.vue?vue&type=template&id=5e302d7b&scoped=true", function () {
      api.rerender('5e302d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/components/CsgDataForm.vue"
export default component.exports